export default __webpack_public_path__ + "static/media/nasa.c39a0c9b.jpg";